module.exports = __webpack_public_path__ + "img/15.317c4492.jpg";